// extracted by css-extract-rspack-plugin
var _1 = "PJskpUnwFhIlCIDu";
export { _1 as "primaryBadgeStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "PJskpUnwFhIlCIDu";
export { _1 as "primaryBadgeStyle" }
